import React, { useState, useEffect } from "react";
import "./nav.css";
import { AiOutlineUser } from "react-icons/ai";
import { BiBook, BiBriefcase } from "react-icons/bi";
import { BiMessageSquareDetail } from "react-icons/bi";

const Nav = () => {
  const [activeNav, setActiveNav] = useState("/");

  useEffect(() => {
    const path = window.location.pathname;
    if (["/", "/experience", "/portfolio", "/contact"].includes(path)) {
      setActiveNav(path);
    }
  }, []);

  const handleNavClick = (e, path, targetId) => {
    e.preventDefault();
    setActiveNav(path);
    window.history.pushState({}, "", path);
    
    const element = document.getElementById(targetId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav>
      <a
        href="/"
        onClick={(e) => handleNavClick(e, "/", "home")}
        className={activeNav === "/" ? "active" : ""}
      >
        <AiOutlineUser />
      </a>
      <a
        href="/experience"
        onClick={(e) => handleNavClick(e, "/experience", "experience")}
        className={activeNav === "/experience" ? "active" : ""}
      >
        <BiBook />
      </a>
      <a
        href="/portfolio"
        onClick={(e) => handleNavClick(e, "/portfolio", "portfolio")}
        className={activeNav === "/portfolio" ? "active" : ""}
      >
        <BiBriefcase />
      </a>
      <a
        href="/contact"
        onClick={(e) => handleNavClick(e, "/contact", "contact")}
        className={activeNav === "/contact" ? "active" : ""}
      >
        <BiMessageSquareDetail />
      </a>
    </nav>
  );
};

export default Nav;
